export const slug = "interactive.2019.enterprise";

export const colors = {
  black: "black",
  white: "white",
  lightgray: "#F1F1F1",
  gray: "#E2E2E2",
  darkgray: "#D2D2D2",
  darkblue: "#0080C6",
  midblue: "#0080C6",
  lightblue: "#91C4E0"
};

export const fonts = {
  titleFont: "Nunito",
  headerFont: "Nunito",
  textFont: "'Avenir Next'"
};

export const mediaQueries = {
  mobile: "@media (max-width: 700px)",
  notMobile: "@media (min-width: 701px)",
  tablet: "@media (max-width: 1200px)",
  notTablet: "@media (min-width: 1201px)",
  smol: "@media (max-width: 1300px)"
};
